<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useApiClient } from "@/api/client";
import { useCampaignPlannerStore } from "../../store";
import OpportunityHeader from "./OpportunityHeader.vue";
import FlightTable from "./FlightTable.vue";
import AddFlightDialog from "./AddFlightDialog.vue";
import OpportunityDO = Modules.CampaignPlanner.Data.OpportunityDO;
import FlightSummaryDTO = Modules.CampaignPlanner.Data.FlightSummaryDTO;

const store = useCampaignPlannerStore();

const opportunity_uuid: string = (
	useRoute().params.opportunity_uuid ?? ""
).toString();

const opportunity = ref<OpportunityDO | null>(null);
const flights = ref<FlightSummaryDTO[]>([]);
const loadingOpportunity = ref(true);
const loadingFlights = ref(true);
const showAddFlightDialog = ref(false);

const loadOpportunity = async () => {
	loadingOpportunity.value = true;
	const response = await useApiClient("campaignPlanner").getOpportunity(
		opportunity_uuid
	);
	if (response.isOk()) {
		opportunity.value = response.value;
		store.setBreadcrumbs([
			{
				title: "Opportunities",
				disabled: false,
				to: "/campaign-planner/opportunities/listing",
			},
			{ title: response.value.name, disabled: true, to: "" },
		]);
	}
	loadingOpportunity.value = false;
};

const loadFlights = async () => {
	loadingFlights.value = true;
	const response = await useApiClient("campaignPlanner").getOpportunityFlights(
		opportunity_uuid
	);
	if (response.isOk()) flights.value = response.value;
	loadingFlights.value = false;
};

onMounted(() => {
	loadOpportunity();
	loadFlights();
});
</script>

<template>
	<div v-if="loadingOpportunity" class="mt-5">
		<v-skeleton-loader type="heading" class="mb-2" />
		<v-skeleton-loader type="text" width="40%" />
		<v-skeleton-loader type="text" width="30%" />
		<v-skeleton-loader type="text" width="35%" />
	</div>

	<template v-else-if="opportunity">
		<opportunity-header
			:opportunity="opportunity"
			@add-flight="showAddFlightDialog = true"
		/>
		<div class="mt-5 px-5">
			<flight-table
				:flights="flights"
				:loading="loadingFlights"
				@flight-deleted="loadFlights"
			/>
		</div>
		<add-flight-dialog
			v-model="showAddFlightDialog"
			:opportunity-uuid="opportunity_uuid"
		/>
	</template>
</template>
